import React from 'react'
import { compose } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

import styled from 'styled-components'
import FormInput from './Input'
import Button from './Button'
import Checkbox from './Checkbox'
import { getIsRuServer } from '../../helpers/getIsRuServer'

const validate = (values) => {
  const errors = {}
  if (!values.username) {
    errors.username = 'forms:required'
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.username)
  ) {
    errors.username = 'forms:invalidEmail'
  }
  if (!values.password) {
    errors.password = 'forms:required'
  }

  return errors
}
const StyledFormTitle = styled.div`
  font-family: 'Open Sans', sans-serif;
  color: #727272;
  font-weight: 600;
  margin-bottom: 25px;
`

const StyledBottomControl = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledForgotButton = styled.div`
  text-align: right;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  a {
    color: #b0bac9;
    transition: all 0.2s;
  }

  a:hover {
    text-decoration: none;
  }
`

const StyledNoAccount = styled.div`
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #b0bac9;
  margin-top: 10px;

  .link {
    color: #4c84ff;

    &:hover {
      text-decoration: none;
    }
  }
`

const AuthForm = ({ handleSubmit, loading, t, i18n }) => {
  const noAccountButtonLink = getIsRuServer()
    ? 'https://hrs.ru/ru/contact-us/'
    : 'http://support.hrsinternational.com/crm/index.php'

  return (
    <React.Fragment>
      <StyledFormTitle>{t('forms:signIn')}</StyledFormTitle>
      <form onSubmit={handleSubmit}>
        <Field
          name="username"
          type="email"
          component={FormInput}
          label={t('forms:email')}
          t={t}
        />
        <div>
          <Field
            name="password"
            type="password"
            component={FormInput}
            label={t('forms:password')}
            t={t}
          />
        </div>
        <StyledBottomControl>
          <Field
            id="remember"
            name="remember"
            type="checkbox"
            component={Checkbox}
            label={t('forms:remember')}
          />
          <StyledForgotButton>
            <Link to="/restore-password">{t('forms:restorePassword')}</Link>
          </StyledForgotButton>
        </StyledBottomControl>
        <Button disabled={loading}>{t('forms:signIn')}</Button>
        <StyledNoAccount>
          {t('phrases:noAccount:0')}{' '}
          <a href={noAccountButtonLink} className="link" target="_blank">
            {t('phrases:noAccount:1')}
          </a>
        </StyledNoAccount>
      </form>
    </React.Fragment>
  )
}

export default compose(
  reduxForm({
    form: 'auth',
    validate,
    initialValues: {
      // only for testing purposes
      username: '',
      password: ''
    }
  }),
  withNamespaces()
)(AuthForm)
